import { createSignal } from 'solid-js';
import { BottomSheet } from './BottomSheet';
import { handleExportPdf, handleExportPng } from './exportHandlers';
import { pdfExporting, pngExporting } from './uiState';

export function ExportMenu() {
  const [open, setOpen] = createSignal(false);
  const busy = () => pdfExporting() || pngExporting();

  function close() {
    if (busy()) return;
    setOpen(false);
  }

  async function onPdf() {
    await handleExportPdf();
    setOpen(false);
  }

  async function onPng() {
    await handleExportPng();
    setOpen(false);
  }

  return (
    <>
      <button
        type="button"
        class="export-menu__btn"
        aria-label="Open export menu"
        onClick={() => setOpen(true)}
      >
        ⋮
      </button>
      <BottomSheet open={open()} onClose={close}>
        <div class="bottom-sheet__header">Export</div>
        <button
          type="button"
          class="bottom-sheet__item"
          data-export="pdf"
          disabled={busy()}
          onClick={() => void onPdf()}
        >
          {pdfExporting() ? 'Generating…' : 'Export PDF'}
        </button>
        <button
          type="button"
          class="bottom-sheet__item"
          data-export="png"
          disabled={busy()}
          onClick={() => void onPng()}
        >
          {pngExporting() ? 'Generating…' : 'Export PNG'}
        </button>
        <button
          type="button"
          class="bottom-sheet__item bottom-sheet__item--secondary"
          data-export="cancel"
          disabled={busy()}
          onClick={() => setOpen(false)}
        >
          Cancel
        </button>
      </BottomSheet>
    </>
  );
}
